
// CACHES
import C1 from './ChartsList.js';

export default [
	C1
];
